import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Button,
  Loader,
  Icon,
  Modal
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { reportActions } from '../../actions/report.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { DateTimeInput } from 'semantic-ui-calendar-react-17';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class WorkJourneyScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        username: null,
        period: '',
        request: {
          username: '',
          date: ''
        },
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  handleUsernameChange(username) {
    this.setState({ username, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, username, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(reportActions.fetchWorkJourney({ page, username, startDate, endDate, orderBy: "Date", export: isExport ? true : null, ascending: false }));
  }

  handleChange(field, data) {    
    const { request } = this.state;    
    request[field] = data;    
    this.setState({ request });    
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { request } = this.state;
    let payload = {
      username: request.username,
      date: moment(request.date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
    };

    dispatch(reportActions.create(payload)).then(() => {
      this.fetchRegisters()
    });    
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;    

    return (
      <Fragment>
        <Header>
          <h1>Histórico Jornada de Trabalho</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Data'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Username' onChange={(e, data) => this.handleUsernameChange(data.value)} loading={loading} />
            
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> Exportar
            </Form.Button>            
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>                                      
                    <Table.HeaderCell>Data</Table.HeaderCell>                      
                    <Table.HeaderCell>Nome</Table.HeaderCell>                    
                    <Table.HeaderCell>Username</Table.HeaderCell>                    
                    <Table.HeaderCell>Início Jornada Padrão</Table.HeaderCell>
                    <Table.HeaderCell>Início Jornada</Table.HeaderCell>
                    <Table.HeaderCell>Ponto Entrada</Table.HeaderCell>
                    <Table.HeaderCell>Término Jornada</Table.HeaderCell>
                    <Table.HeaderCell>Limite Jornada</Table.HeaderCell>                    
                </Table.Row>
            </Table.Header>
            <Table.Body>              
                { registers && registers.Results && registers.Results.map((register) => {
                    return <Table.Row key={register.Id}>                 
                        <Table.Cell>{moment(register.Date).format('DD/MM/YYYY')}</Table.Cell>    
                        <Table.Cell>{register.User.Name}</Table.Cell>                           
                        <Table.Cell>{register.User.Username}</Table.Cell>                        
                        <Table.Cell>{register.DefaultJourneyStart ? moment(register.DefaultJourneyStart).format('HH:mm') : '-'}</Table.Cell>
                        <Table.Cell>{register.JourneyStart ? moment(register.JourneyStart).format('HH:mm') : '-'}</Table.Cell>
                        <Table.Cell>{register.ClockRegisterStart ? moment(register.ClockRegisterStart).format('HH:mm') : '-'}</Table.Cell>
                        <Table.Cell>{register.JourneyEnd ? moment(register.JourneyEnd).format('HH:mm') : '-'}</Table.Cell>
                        <Table.Cell>{register.JourneyMax ? moment(register.JourneyMax).format('HH:mm') : '-'}</Table.Cell>                        
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;  

  
  return {
    registers: report?.workJourney || null,
    loading: report?.workJourney?.loading
  };
}

const connectedWorkJourneyScreen = connect(mapStateToProps)(WorkJourneyScreen);
export { connectedWorkJourneyScreen as WorkJourneyScreen };
